<div class="toggle-group-container" [style.backgroundColor]="color ? color : ''">
  @for (option of options; track option; let i = $index) {
    <div class="slider" [ngStyle]="sliderStyle"></div>
    <button
      #toggleOption
      type="button"
      class="toggle-button"
      [style.color]="color && i === selectedOptionIndexSignal() ? color : ''"
      [class.active]="i === selectedOptionIndexSignal()"
      (click)="selectOption(i)"
    >{{ option.label | translate }}
    </button>
  }
</div>
